import { ReactComponent as Linkedin } from "./linkedin.svg";
import { ReactComponent as Github } from "./github.svg";
import { ReactComponent as Email } from "./email.svg";
import { ReactComponent as Home } from "./home.svg";
import { ReactComponent as Contact } from "./contact.svg";
import { ReactComponent as About } from "./about.svg";
import { ReactComponent as Resume } from "./resume.svg";
import { ReactComponent as Experience } from "./experience.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as Close } from "./close.svg";
const IconList = {
  Linkedin,
  Github,
  Email,
  Home,
  Contact,
  About,
  Resume,
  Experience,
  MenuIcon,
  Close,
};

export default IconList;
